<!--
    字体编辑下拉菜单
    作用：提供字体、字号选择等下拉的菜单组件；
    实现：下拉菜单；
    组件：el-dropdown，对应dropData.js，familyData，fontSizeData
    注释：WJ
-->
<template>
    <div class="drop-box-list">
        <el-dropdown
            class="drop"
            trigger="click"
            @command="handleCommand"
        >
            <span class="el-dropdown-link">
             下拉菜单
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                    v-for="(item, index) in newForm"
                    :command="item.key"
                    :key="index"
                >{{item.value}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    export default {
        name: "drop-box",
        props: {
            form: Array,
        },
        watch: {
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form', vl)}
        },
        data() {
            return {
                newForm: this.form
            }
        },
        methods: {
            handleCommand(value){
                this.$emit('onDropSelect', value)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .drop-box-list{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;

        .drop{
            width: 100%;
            height: 109%;
            position: relative;
            top: -2px;

            .el-dropdown-link{
                display: inline-block;
                width: 100%;
                height: 100%;
                opacity: 0;
            }
        }
    }

</style>
